module.exports = __webpack_public_path__ + "static/media/logo-drawer.e775728c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-drawer.png
// module id = 758
// module chunks = 0